import { Button } from 'components/UI/Interactables/Button';
import { Typography } from 'components/UI/Typography';
import { Svgs, Colors } from 'environment';
import { useNavigation } from 'hooks/navigation';
import { useTranslation } from 'hooks/store';

export function UnauthorizedPage() {
	const { goBack } = useNavigation();
	const { translate } = useTranslation();

	return (
		<div className="flex flex-col h-screen justify-center items-center py-12 px-16">
			<Svgs.LedidiLogoColored height={200} width={200} />

			<Typography.H1
				fontweight={w => w.normal}
				color={Colors.primary.normal}
				marginOffset={{ bottom: 2 }}
			>
				{translate(dict => dict.unauthorizedPage.title)}
			</Typography.H1>

			<Typography.Paragraph
				fontSize="2.2rem"
				fontweight={w => w.normal}
				css="line-height: 1.64;"
				marginOffset={{ bottom: 4 }}
			>
				{translate(dict => dict.unauthorizedPage.message)}
			</Typography.Paragraph>

			<Button
				variant={v => v.outline}
				title={translate(dict => dict.buttons.goBack)}
				marginOffset={{ bottom: 8 }}
				onClick={goBack}
			/>
		</div>
	);
}
